import { ContentPreview } from '@app/store/shared';
import { SECONDS_PER_DAY, Time } from '@app/shared/classes';
import { DEFAULT_PATHWAY_TYPE, PathwayType } from '@app/shared/types';
import { CourseDto, InstructorDto } from './course.dto';
import { LessonType } from '../../lesson';

export const sortedLessonsTypes: LessonType[] = ['video', 'text', 'audio'];
export class Course {
    id: string;
    name: string;
    placeholder: {
        landscape: string | null;
        portrait: string | null;
    };
    description: string | null;
    duration: number; // in seconds
    rating: number; // average rating
    participants: number; // number of participants
    instructor: Instructor | null;
    objectives: string[]; // learning objectives
    tags: string[]; // tags associated with the course
    lessonsTypes: LessonType[]; // array of lesson types
    sortedLessonTypes: LessonType[];
    materialIds: string[]; // list of course material IDs
    moduleNext: ContentPreview | null; // next module to be completed
    modules: ContentPreview[];
    deadline: Date | null = null;
    dueInSeconds: number | null = null;
    orderRestricted: boolean;
    type: PathwayType;
    access: boolean;
    hasAssessment: boolean;

    constructor(data: CourseDto) {
        this.id = data.id;
        this.name = data.name;
        this.placeholder = {
            landscape: data.placeholder,
            portrait: data.placeholderPortrait,
        };
        this.description = data.description?.trim() ? data.description : null;
        this.duration = data.duration ?? 0;
        this.rating = data.rating;
        this.participants = data.participants;
        this.instructor = data.instructor ? new Instructor(data.instructor) : null;
        this.objectives = [...data.objectives];
        this.tags = [...data.tags];
        this.lessonsTypes = data.lessonsTypes;
        this.materialIds = data.materialIds ?? [];
        this.moduleNext = data.moduleNext ? new ContentPreview(data.moduleNext) : null;
        this.modules = data.modules.map((module) => new ContentPreview(module));
        this.sortedLessonTypes = [...(this.lessonsTypes ?? [])].sort((a, b) => sortedLessonsTypes.indexOf(a) - sortedLessonsTypes.indexOf(b)) || [];
        this.orderRestricted = data.orderRestricted;
        this.type = data.learningType ?? DEFAULT_PATHWAY_TYPE;
        this.access = data.access ?? true;
        this.hasAssessment = data.hasAssessment ?? false;

        if (data.deadline && Time.stringIsDate(data.deadline)) {
            this.deadline = new Date(data.deadline);
            this.dueInSeconds = Time.diffDays(this.deadline, Time.today()) * SECONDS_PER_DAY;
        }
    }
}

export class Instructor {
    firstname: string;
    lastname: string;
    fullname: string;
    degree: string | null;
    university: string | null;
    image: string | null;

    constructor(data: InstructorDto) {
        this.firstname = data.firstname ?? '';
        this.lastname = data.lastname ?? '';
        this.fullname = `${this.firstname} ${this.lastname}`.trim();
        this.degree = data.degree;
        this.university = data.university;
        this.image = data.image;
    }
}
